export const COMMON_EMPTY_SCHEDULE = 'common:empty_schedule';
export const COMMON_DOWNLOAD_PDF = 'common:download_pdf';
export const COMMON_DOWNLOAD_ICS = 'common:download_ics';
export const COMMON_ICS_HINT = 'common:ics_hint';
export const COMMON_ADD_LESSON_TO_CALENDAR = 'common:add_lesson_to_calendar';
export const COMMON_ODD_WEEK = 'common:odd_week';
export const COMMON_EVEN_WEEK = 'common:even_week';
export const COMMON_DELETE_SCHEDULE_ITEM = 'common:delete_schedule_item';
export const COMMON_EDIT_SCHEDULE_ITEM = 'common:edit_schedule_item';
export const COMMON_SELECT_GROUP_SCHEDULE = 'common:select_group_schedule';
export const COMMON_EDIT = 'common:edit';
export const COMMON_SET_DISABLED = 'common:set_disabled';
export const COMMON_CREATE = 'common:create';
export const COMMON_SEMESTER = 'common:semester';
export const COMMON_BY_DATE_LABEL = 'common:by_date_label';
export const COMMON_CURRENT_LABEL = 'common:current_label';
export const COMMON_DEFAULT_LABEL = 'common:default_label';
export const COMMON_YEAR_LABEL = 'common:year_label';
export const COMMON_CHOOSE_GROUPS_BUTTON_LABEL = 'common:choose_groups_button_label';
export const COMMON_SEMESTER_LABEL = 'common:semester_label';
export const COMMON_CLASS_FROM_LABEL = 'common:class_from_label';
export const COMMON_CLASS_TO_LABEL = 'common:class_to_label';
export const COMMON_DAYS_LABEL = 'common:days_label';
export const COMMON_CLASS_SCHEDULE_MANAGEMENT_TITLE = 'common:ClassSchedule_management_title';
export const COMMON_SAVE_BUTTON_LABEL = 'common:save_button_label';
export const COMMON_LIST_VIEW = 'common:list_view';
export const COMMON_SELECT_DATES_FOR_TEACHERS_SCHEDULE = 'common:select_dates_for_teacher_schedule';
export const COMMON_BLOCK_VIEW = 'common:block_view';
export const COMMON_CLASS_SCHEDULE = 'common:class_schedule';
export const COMMON_EDIT_HOVER_TITLE = 'common:edit_hover_title';
export const COMMON_DELETE_HOVER_TITLE = 'common:delete_hover_title';
export const COMMON_FEW_DAYS_LABEL = 'common:few_days_label';
export const COMMON_DATE_LABEL = 'common:date';
export const COMMON_HOLIDAY_LABEL = 'common:holiday_label';
export const COMMON_NOTIFY_LABEL = 'common:notify_label';
export const COMMON_NAME_LABEL = 'common:name_label';
export const COMMON_TYPE_LABEL = 'common:type_label';
export const COMMON_BYTE_SIZE_LABEL = 'common:byte_size_label';
export const COMMON_UPLOAD_TITLE = 'common:upload_title';
export const COMMON_MY_PROFILE = 'common:my_profile';
export const COMMON_MAKE_ARCHIVE = 'common:make_archive';
export const COMMON_PREVIEW = 'common:preview';
export const COMMON_SET_ENABLED = 'common:set_enabled';
export const COMMON_SEMESTER_IS_NOT_UNIQUE = 'common:semester_service_is_not_unique';
export const COMMON_SCHEDULE_TITLE = 'common:schedule_title';
export const COMMON_LESSON_SERVICE_IS_NOT_UNIQUE = 'common:lesson_service_is_not_unique';
export const COMMON_NO_BUTTON_TITLE = 'common:no_button_title';
export const COMMON_ERROR_MESSAGE = 'common:error_message';
export const COMMON_REGULAR_LESSON_LABEL = 'common:regular_lesson_label';
export const COMMON_LINK_TO_MEETING_WORD = 'common:link_to_meeting_word';
export const COMMON_VACATION_LABEL = 'common:vacation_label';
export const COMMON_GROUP_TITLE = 'common:group_title';
export const LOGIN_TITLE = 'login_title';
export const SEMESTER_LABEL = 'semester_label';
export const REGISTRATION_PAGE_TITLE = 'registration_page_title';
export const RESET_PASSWORD_PAGE_TITLE = 'reset_password_page_title';
export const RESET_PASSWORD_LABEL = 'common:reset_password_button';
export const LOGOUT_TITLE = 'logout_title';
export const ADMIN_TITLE = 'admin_title';
export const HOME_TITLE = 'home_title';
export const SCHEDULE_TITLE = 'schedule_title';
export const COMMON_STUDENT_TITLE = 'common:student_title';
export const MY_PROFILE = 'my_profile';
export const SENT_SCHEDULE = 'sent_schedule';
export const SCHEDULE_FOR_SEMESTER = 'schedule_for_semester';
export const CONFIRM_GROUPS = 'confirm_groups';
export const CHOOSE_TEACHER = 'choose_teachers';
export const CHOOSE_GROUPS = 'choose_groups';
export const ALL_TEACHERS = 'all_teachers';
export const ALL_GROUPS = 'all_groups';
export const TEACHER_CARD_NO_CARD = 'teacher_card_no_cards';
export const TEACHER_DEPARTMENT = 'teacher_department';
export const SEND_SCHEDULE_FOR_TEACHER = 'send_schedule_for_teacher';
export const WEEK_LABEL = 'week_label';
export const EDIT_HOVER_TITLE = 'edit_hover_title';
export const DELETE_HOVER_TITLE = 'delete_hover_title';
export const BUSY_ROOMS_HEADING = 'busy_rooms_heading';
export const SUCCESSFUL_LOGIN_MESSAGE = 'successful_login_message';
export const SUCCESSFUL_REGISTERED_MESSAGE = 'successful_registered_message';
export const LESSON_FOR_GROUP_TITLE = 'lesson_for_group_title';
export const TEMPORARY_SCHEDULE_FOR_TEACHER_TITLE = 'temporary_schedule_for_teacher_title';
export const LESSON_NO_LESSON_FOR_GROUP_LABEL = 'lesson_no_lesson_for_group_label';
export const WEEK_ODD_TITLE = 'week_odd_title';
export const WEEK_EVEN_TITLE = 'week_even_title';
export const CLASS_SCHEDULE = 'class_schedule';
export const DELETE_LESSON = 'delete_lesson';
export const EDIT_LESSON = 'edit_lesson';
export const COPY_LESSON = 'copy_lesson';
export const COPY_TO_SAME_GROUP_ERROR = 'copy_to_same_group_error';
export const EMPTY_LABEL = 'empty';
export const EMPTY_FIELDS = 'empty_fields';
export const DIFFERENT_PASSWORDS = 'different_passwords';
export const ACCOUNT_EXIST = 'account_exist';
export const CREATE_ACCOUNT = 'create_account';
export const VERIFYING_TOKEN = 'verifying_token';
export const TOKEN_ERROR = 'token_error';
export const COMMON_SCHEDULE_DIALOG_TITLE = 'common:schedule_dialog_title';
export const COMMON_CHOOSE_GROUP = 'common:choose_group';
export const GREETING_SCHEDULE_MESSAGE = 'greetings_schedule_message';
export const GREETING_SCHEDULE_MESSAGE_HINT = 'greetings_schedule_message_hint';
export const FULL_SCHEDULE_LABEL = 'full_schedule_label';
export const COMMON_ROOM_IS_UNAVAILABLE = 'common:room_is_unavailable';
export const COMMON_AVAILABLE = 'common:available';
export const COMMON_UNAVAILABLE = 'common:unavailable';
export const COMMON_TEACHER_IS_UNAVAILABLE = 'common:teacher_is_unavailable';
export const COMMON_CLASS_DOES_NOT_SUIT_FOR_TEACHER = 'common:class_does_not_suit_for_teacher';
export const COMMON_YES_BUTTON_TITLE = 'common:yes_button_title';
export const COMMON_ARE_YOU_SURE = 'common:are_you_sure';
export const COMMON_CLOSE_TITLE = 'common:close_title';
export const COMMON_UPLOAD_FROM_FILE_TITLE = 'common:upload_from_file_title';
export const UPLOAD_FROM_FILE = 'upload_from_file';
export const TYPE_LABEL = 'type_label';
export const COMMON_MOVE_LABEL = 'common:move_label';
export const MOVE_TO_GROUP_TITLE = 'move_to_group_title';
export const COMMON_MOVE_TO_GROUP_TITLE = 'common:move_to_group_title';
export const CANCEL_BUTTON_LABEL = 'cancel_button_label';
export const COMMON_SHOW_DISABLED = 'common:show_disabled';
export const COMMON_SHOW_ENABLED = 'common:show_enabled';
export const NO_CURRENT_SEMESTER = 'no_current_semester';
export const NO_CURRENT_SEMESTER_ERROR = 'common:no_current_semester_error';
export const USE_PC = 'use_pc';
export const EMPTY_SCHEDULE = 'empty_schedule';
export const MENU_BUTTON = 'menu_button';
export const CLEAR_SCHEDULE_LABEL = 'clear_schedule_label';
export const FOR_ALL = 'for_all';
export const DATE_LABEL = 'date';
export const ONE_DAY_LABEL = 'one_day';
export const TEACHER_SCHEDULE_LABEL = 'teacher_schedule_label';
export const BROKEN_TOKEN = 'broken_token';
export const SUCCESSFUL_RESET_PASSWORD_MESSAGE = 'successful_reset_password_message';
export const PLACE_FOR_CLASS_LABEL = 'place_for_class_label';
export const COMMON_DO_YOU_WANNA = 'common:do_you_wanna';
export const COMMON_DO_YOU_WANNA_DISABLE = 'common:do_you_wanna_disable';
export const COMMON_DELETE_WORD = 'common:delete_word';
export const COMMON_DO_YOU_WANNA_SHOW = 'common:do_you_wanna_show';
export const COMMON_BY_THIS_CARD_TYPE = 'common:by_this_card_type';
export const COMMON_THIS_CARD_TYPE = 'common:this_card_type';
export const COMMON_GO_TO_MEETING_WORD = 'common:go_to_meeting_word';
export const COMMON_SET_DEFAULT_WORD = 'common:set_default_word';
export const COMMON_MORE_LABEL = 'common:more_label';
export const TEACHER_LIST_TITLE = 'TeacherList_management_title';
export const GROUP_LIST_TITLE = 'GroupList_management_title';
export const CLASS_SCHEDULE_TITLE = 'ClassScheduleTitle_management_title';
export const ROOM_LIST_TITLE = 'RoomList_management_title';
export const SUBJECT_PAGE_TITLE = 'SubjectPage_management_title';
export const SEMESTER_PAGE_TITLE = 'SemesterPage_management_title';
export const DEPARTMENTS_TITLE = 'Departments_management_title';
export const LESSON_PAGE_TITLE = 'LessonPage_management_title';
export const CHANGES_TITLE = 'Changes_management_title';
export const BUSY_ROOMS_TITLE = 'BusyRooms_management_title';
export const GENERAL_TITLE = 'General_management_title';
export const SELECT_FILE = 'common:select_file';
export const SELECT_CORRECT_FORMAT = 'common:select_correct_format';
export const FILE_RULES_FOR_EACH_LNE = 'common:file_rules_for_each_line';
export const FILE_RULES_FOR_HEADER = 'common:file_rules_for_header';
export const EXAMPLE_FILE = 'common:example_file';
export const COMMON_TABLE_COLUMNS_SIZE = 'table_columns_size';
export const COMMON_TABLE_COLUMNS_SIZE_SMALL = 'columns_size_small';
export const COMMON_TABLE_COLUMNS_SIZE_BASE = 'columns_size_base';
export const COMMON_TABLE_COLUMNS_SIZE_LARGE = 'columns_size_large';

export const TEACHER_LESSONS_TITLE = 'teacher_lessons_title';

export const CLEAR_CACHE_TITLE = 'clear_cache_title';
export const CLEAR_CACHE_CONFIRM = 'clear_cache_confirm';
export const CLEAR_CACHE_SUCCESS = 'clear_cache_success';
export const CLEAR_CACHE_ERROR = 'clear_cache_error';
export const CLEAR_CACHE_BUTTON = 'clear_cache';
export const CLEARING_CACHE = 'clearing_cache';
export const COMMON_MOVE = "common:move"

export const CURRICULUM_TITLE = "curriculum_title";
export const LESSONS_FROM_CURRICULUM_TITLE = "lessons_from_curriculum_title";

export const FROM_CURRICULUM_CURRENT_SEMESTER = "from_curriculum_current_semester";
export const FROM_CURRICULUM_SELECT_GROUP = "from_curriculum_select_group";
export const FROM_CURRICULUM_LOADING = "from_curriculum_loading";
export const FROM_CURRICULUM_NO_PLAN = "from_curriculum_no_plan";
export const FROM_CURRICULUM_SELECT_TEACHER_FIRST = "from_curriculum_select_teacher_first";
export const FROM_CURRICULUM_FINISH_SELECTION = "from_curriculum_finish_selection";
export const FROM_CURRICULUM_CREATE_SELECTED = "from_curriculum_create_selected";
export const FROM_CURRICULUM_CREATED_RESULT = "from_curriculum_created_result";
export const FROM_CURRICULUM_LEAVE_CONFIRM = "from_curriculum_leave_confirm";
export const FROM_CURRICULUM_UNPLANNED_TITLE = "from_curriculum_unplanned_title";
export const FROM_CURRICULUM_UNPLANNED_HINT = "from_curriculum_unplanned_hint";
export const FROM_CURRICULUM_DELETE_LESSON = "from_curriculum_delete_lesson";
export const FROM_CURRICULUM_GROUPS_COLUMN = "from_curriculum_groups_column";